import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { icons } from "../../colorui/icon";
export default {
  components: {},
  data: function data() {
    return {
      iconList: icons,
      titleIconDialog: false
    };
  },
  props: {
    imgType: {
      type: String,
      default: 'icons'
    }
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    onTitleIcon: function onTitleIcon(item) {
      this.$emit('onChangeIcon', 'cuIcon-' + item.name);
      this.titleIconDialog = false;
    }
  },
  updated: function updated() {},
  beforeDestroy: function beforeDestroy() {},
  destroyed: function destroyed() {},
  //如果页面有keep-alive缓存功能，这个函数会触发
  activated: function activated() {},
  watch: {}
};